<!-- =========================================================================================
  File Name: UserEditTabSocial.vue
  Description: User Edit Social Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
        <vs-prompt
            :title="$t('NewAttachment')"
            :accept-text="$t('Save')"
            :cancel-text="$t('Cancel')"
            @cancel="clearAttachmentModal"
            @accept="SaveAttachment"
            @close="clearAttachmentModal"
            :is-valid="validateAttachmentForm"
            :active.sync="activePrompt">
                <VuePerfectScrollbar class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
                    <form @submit.prevent style="max-height:75vh">
                          <div class="mt-5 vx-row w-full " style="padding-left:20px">
                          <div class=" lg:w-3/4" style="padding-left:20px">
                            <vs-input :label="$t('DescriptionOfAttachment')" v-model="attachment.DescriptionOfAttachment" class="mt-5 w-full" name="DescriptionOfAttachment" v-validate="'required'" />
                            <span class="text-danger text-sm" v-show="errors.has('DescriptionOfAttachment')">{{ errors.first('DescriptionOfAttachment') }}</span>
                          </div>
                         <div class="vx-col">
                         <label class="vs-input--label">file</label>
                    <!-- {{CourseQuestionBank.AttachedPicURL}} -->
                     <vs-upload automatic :limit="1" :action="uploadUrl" :headers="UploadRequestHeader"  @on-success="successUpload" /> </div>
                      </div>

                    </form>
                </VuePerfectScrollbar>
          </vs-prompt>

   <div>
    <div class="vx-row">

<div  class="vx-col lg:w-4/4 w-full">
      <vx-card :title="$t('Attachment')" class="mb-base" >
          <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus" @click="activePrompt=true">{{$t('AddAttachment')}}</vs-button>

          <vs-table ref="table"   pagination :max-items="5"  :data="getListOfInstructorAttachment" >
            <template slot="thead">
              <vs-th > {{$t('AttachmentDescription')}}</vs-th>
              <vs-th >{{$t('URL')}}</vs-th>
              <vs-th>{{$t('Action')}}</vs-th>
            </template>

              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                       <p class="product-name font-medium truncate">{{ tr.DescriptionOfAttachment }}</p>
                    </vs-td>
                    <vs-td>
                        <!-- <a :href="tr.UrlAttachment" download>Download</a> -->
                         <a :href="baseURL+tr.UrlAttachment" download target="_blank"><feather-icon icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"  /></a>
                                </vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="openConfirm(tr)" />
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
          </vs-table>
      </vx-card>
</div>
</div>
    </div>
  </div>
</template>


<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { domain,mainSetting } from '@/gloabelConstant.js';
import axios from "@/axios.js";
export default {
  components:{
   VuePerfectScrollbar,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
       baseURL : domain,
       UploadRequestHeader:mainSetting.UploadRequestHeader,
       activePrompt:false,
      instructorModel: this.data,
       settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },
      attachment:{},
      dataForDeleted:{},
      listOfInstructorAttachment:[],
      uploadUrl:domain+"API/Course/UploadFile",
    }
  },
  computed: {
    validateAttachmentForm() {
      return this.attachment.DescriptionOfAttachment !=undefined;
    },
    getListOfInstructorAttachment(){
      return this.instructorModel.Attachments;
    },
  },
  methods: {
    successUpload(event) {
       debugger;
         this.attachment.UrlAttachment= event.target.responseText;
          this.$vs.notify({ color: 'success',
           title:this.$t("UploadSuccess"),
          text: this.$t("SuccessuploadyourAttachment") })
        },
    SaveAttachment()
    {
         if(! this.instructorModel.Attachments)
             this.instructorModel.Attachments=[]
      this.instructorModel.Attachments.push(this.attachment);
          //this.deletefacility(this.facility);
         // this.$store.commit("classRoomList/ADD_Facility", this.facility);
          this.clearAttachmentModal();

    },

     clearAttachmentModal() {
      this.attachment = {}
    },

    openConfirm(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm"),
        text: this.$t("Areyousureyouwantdeletethisrecord")+"?",
        accept: this.acceptAlert
      });
    },
     acceptAlert() {
    debugger;
      this.deleteAttachment(this.rowDataForDelete);
      this.$vs.notify({
        color: "danger",
        title:this.$t("Deletedrecord"),
          text: this.$t("Theselectedrecordwassuccessfullydeleted")
      });
    },
    deleteAttachment(data) {
      debugger;
      if(data.ID>0)
      {
         this.$store.dispatch("instructorList/removeAttachment",  data.ID);
      }
      debugger;
    const ItemIndex = this.instructorModel.Attachments.findIndex((p) => p.DescriptionOfAttachment == data.DescriptionOfAttachment)
     //if(ItemIndex!=-1)
          this.instructorModel.Attachments.splice(ItemIndex, 1)
    },
  },
  created(){
    debugger;
    if(this.instructorModel.Attachments.length>0)
    {
     this.listOfInstructorAttachment= this.instructorModel.Attachments;
    }

  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
